import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form/immutable';
import { compose, mapProps } from 'recompose';
import moment from 'moment';

import Button from '../../../../app/components/Button';
import { DateInput } from '../../../../app/components/Form';
import { Endpoints } from '../../../../app/lib/LeanLinkService';
import * as styles from '../styles.css';
import { useTranslation } from 'react-i18next';

function Form({ handleSubmit }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.form}>
        <Field
          label={t("Från")}
          name="from"
          component={DateInput}
          compact
        />
        <Field
          label={t("Till")}
          name="to"
          component={DateInput}
          compact
        />
      </div>
      <Button
        icon="clock-o"
        onClick={handleSubmit}
        variant="primary"
        type="submit"
        stretch
      >
        {t("Visa rapporterade tider")}
      </Button>
    </div>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default compose(
  mapProps(({ fetchReportedPeriods }) => ({
    onSubmit: (values) => {
      fetchReportedPeriods(
        Endpoints.public.resourceApi.reportedPeriods(values.toJS()),
      );
    },
    initialValues: {
      from: moment().add(-1, 'month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
    },
  })),
  reduxForm({
    form: 'reported_times',
  }),
)(Form);
